$(document).ready(function() {
  bsConfirmations();
  fullCalendar();
  changeRequest();
  clickableTr();
  colspans();
  collapseIconChange();
  closeNotification();
  disableBtn();
  fakeDateField();
  initilizeUppy();
  inlineUpdate()
  sampleRequest();
  selectpicker();
  showScheduleBtn();
  tagContacts();
  toggleFields();
  tooltip();
  updateSelect();
  changeCalendarOption();
});

$(document).ajaxComplete(function() {
  closeNotification();
  changeRequest();
  disableBtn();
  fakeDateField();
  initilizeUppy();
  selectpicker();
  toggleFields();
  updateSelect();
});


$(window).on('scroll', function(event) {
  var scrollValue = $(window).scrollTop();
  var windowHeight = $(window).height();
  $('#files-col').width($("#col-parent").width());
  $('#files-col').height(windowHeight - 150);
  if (scrollValue >= 58) {
    $('#files-col').addClass('position-fxd');
  } else if (scrollValue <= 58) {
    $('#files-col').removeClass('position-fxd');
  }
});

window.closeNotification = function() {
  $("#close_notification").click(function() {
    $("#notification_toast").animate({opacity: 0}, {duration: 300})
    setTimeout(function() { $("#notification_toast").hide(); }, 2000);
  })
}

window.changeCalendarOption = function() {
  $('#calendar_option').change (function() {
    if ($('#customer_operations').length > 0) {
      if ($(this).val() == 'operator') {
        var url = '/customers/get_operators_filter_options'
      } else if ($(this).val() == 'activity') {
        var url = "/customers/" + $("#customer_id").val() + "/get_activities_filter_options"
      } else if ($(this).val() == 'role_operator') {
        var url = '/customers/get_role_operators_filter_options'
      }
    } else {
      if ($(this).val() == 'operator') {
        var url = 'operators/get_filter_options'
      } else if ($(this).val() == 'activity') {
        var url = 'activities/get_filter_options'
      } else if ($(this).val() == 'role_operator') {
        var url = 'operator_roles/get_filter_options'
      }
    }
    var target = $('#filter_option').val("");
    $.ajax({
      type: 'GET',
      url: url,
      success: function(res) {
        target.html("");
        res.forEach(function(v) {
          target.append('<option value="' + v.id + '">' + v.name + '</option>');
        });
      },
      dataType: 'json',
      data: {},
    });
    fullCalendar();
  });
  $('#filter_option').change (function() {
    fullCalendar();
  });
}


window.disableBtn = function() {
  $('#to_disable').mouseenter(function() {
    $(this).children().addClass('disabled')
  })
  .mouseleave(function() {
    $(this).children().removeClass('disabled')
  });
}

window.LightenDarkenColor = function(col, amt) {
  var usePound = false;
    if ( col[0] == "#" ) {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col,16);
    var r = (num >> 16) + amt;

    if ( r > 255 ) r = 255;
    else if  (r < 0) r = 0;

    var b = ((num >> 8) & 0x00FF) + amt;
    if ( b > 255 ) b = 255;
    else if  (b < 0) b = 0;

    var g = (num & 0x0000FF) + amt;
    if ( g > 255 ) g = 255;
    else if  ( g < 0 ) g = 0;

    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}

window.tagContacts = function() {
  if ($('#options').length > 0 ) {
    var customer_id = $('#options').data('customer');
    var url =  "/customers/" + customer_id + "/get_enum";
    $.getJSON(url, function(users){
      $('#message_content').suggest('@', {
        data: users,
        map: function(user) {
          return {
            id: user.id,
            value: user.firstname+user.lastname,
            text: '<strong>'+user.firstname+'</strong> <small>'+user.lastname+'</small>'
          }
        },
        onselect: function(e, item) {
          var index = item['index']
          var value = $('#message_tagged_users').val()
          if (value != '') {
            if (!value.includes(users[index]['id'])) {
              $('#message_tagged_users').val(value + ', ' + users[index]['id'])
            }
          } else {
            $('#message_tagged_users').val(users[index]['id'])
          }
          if ($('#message_tagged_users').val() != '') {
            var username = users[index]['firstname'] + ' ' + users[index]['lastname'];
            if (!$('#list_tagged_users').text().includes(username)) {
              var btn = $('#remove-user').clone();
              btn.removeClass('d-none').addClass('user_tag');
              btn.find('span').append(username);
              btn.attr('id', 'user-' + users[index]['id']).appendTo('#list_tagged_users');
              removeTags();
            }
          }
        }
      });
    });
  }
}

window.removeTags = function() {
  $('.user_tag').each(function(i, el) {
    $(el).click(function() {
      var user_id = $(this).attr('id').split('-')[1];
      $(this).remove();
      var ids = []
      $('.user_tag').each(function(i, el) {
        ids.push($(this).attr('id').split('-')[1]);
      });
      $('#message_tagged_users').val(ids);
    });
  });
}

window.changeRequest = function() {
  $('.material_request').each(function(i, el) {
    var form = $(el).closest('.new_change_request');
    $(el).change(function() {
      if(this.checked) {
        form.find('.new_material_request').removeClass('d-none');
        form.find('.new_material').prop( "disabled", false );
      } else {
        form.find('.new_material_request').addClass('d-none');
        form.find('.new_material').prop( "disabled", true );
      }
    });
  });

  $('.measures_request').each(function(i, el) {
    var form = $(el).closest('.new_change_request');
    $(el).change(function() {
      if (this.checked) {
        form.find('.new_measures_request').removeClass('d-none');
        form.find('.new_height').prop( "disabled", false );
        form.find('.new_length').prop( "disabled", false );
      } else {
        form.find('.new_measures_request').addClass('d-none');
        form.find('.new_height').prop( "disabled", true );
        form.find('.new_length').prop( "disabled", true );
      }
    });
  });

  $('.new_change_request_submit').each(function(i, el) {
    $(el).click(function() {
      var target = $(el).data('target');
      tooltip = $("#" + target);
      var form = tooltip.find('.new_conversation');
      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        success: function(data) {
          if (data['status'] == 200) {
            location.reload();
          } else {
            tooltip.empty().append(data['content']);
            tooltip.find('.close').click(function(){
              tooltip.fadeOut();
            });
          }
        },
        data: form.serialize(),
        dataType: 'json'
      });
    });
  });
}

window.collapseIconChange = function() {
  $("[data-toggle='collapse']").each(function(i,el) {
    $(el).click(function() {
      target = $($(el).data('target'));
      if ($(el).find("svg").length > 0) {
        children = $(el).find("svg");
      } else {
        children = $(el).find("i");
      }
      if ($(el).data('parent') && !target.hasClass('show')) {
        $('.fa-caret-square-down').each(function(j, obj) {
          $(obj).removeClass('fa-caret-square-up');
          $(obj).addClass('fa-caret-square-down');
        });
        $('.bi-arrow-bar-down').each(function(j, obj) {
          $(obj).removeClass('bi-arrow-bar-up');
          $(obj).addClass('bi-arrow-bar-down');
        });
      }
      if (children.hasClass('fa-caret-square-up')) {
        children.removeClass('fa-caret-square-up').addClass('fa-caret-square-down');
      } else if (children.hasClass('bi-arrow-bar-up')) {
        children.removeClass('bi-arrow-bar-up').addClass('bi-arrow-bar-down');
      } else if (children.hasClass('fa-caret-square-down')) {
        children.removeClass('fa-caret-square-down').addClass('fa-caret-square-up');
      } else {
        children.removeClass('bi-arrow-bar-down').addClass('bi-arrow-bar-up');
      }
    });
  });
}

window.initilizeUppy = function() {
  $(".drag-drop-area").each(function(index, el) {
    if ($(el).find('.uppy-Root').length == 0 ) {
      const Uppy = require('@uppy/core')
      const XHRUpload = require('@uppy/xhr-upload')
      const Dashboard = require('@uppy/dashboard')
      require('@uppy/core/dist/style.css')
      require('@uppy/dashboard/dist/style.css')
      const Italian = require('@uppy/locales/lib/it_IT')
      if ($(el).data('uppy-max-files') != 'undefined') {
        uppy_max_files = $(el).data("uppy-max-files");
      } else {
        uppy_max_files = 1
      }
      if ($(el).data('uppy-height') != 'undefined') {
        uppy_height = $(el).data("uppy-height");
      } else {
        uppy_height = 300
      }
      const uppy = Uppy({
        autoProceed: true,
        locale: Italian,
        restrictions: {
          // maxFileSize: 300000,
          maxNumberOfFiles: uppy_max_files,
          minNumberOfFiles: 1
          // allowedFileTypes: ['image/*', 'video/*']
        }
      })
      uppy.use(Dashboard, {
          target: "#" + $(this).prop('id'),
          inline: true,
          height: uppy_height
      });
      uppy.use(XHRUpload, {
        endpoint: $(this).data('url'),
        timeout: 300 * 1000,
        bundle: true
      });
      uppy.on('upload-success', (file, response) => {
        const httpStatus = response.status // HTTP status code
        const httpBody = response.body   // extracted response data
        res = response.body
        if (res.reload == false) {
          // do something with file and response
          if (res.code == 200) {
            $(res.target).html(res.data)
            uppy.reset();
          } else {
            $(res.target).append('<p class="alert alert-danger">' + res.data + '</p>');
          }
        } else {
          location.reload();
        };
      });
      $('.uppy-Dashboard-poweredBy').hide();
    }
  });
}

window.sampleRequest = function() {
  $('.new_sample_request_submit').each(function(i, el) {
    $(el).click(function() {
      var target = $(el).data('target');
      tooltip = $("#" + target);
      var form = tooltip.find('.new_conversation');
      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        success: function(data) {
          if (data['status'] == 200) {
            location.reload();
          } else {
            tooltip.empty().append(data['content']);
            tooltip.find('.close').click(function(){
              tooltip.fadeOut();
            });
          }
        },
        data: form.serialize(),
        dataType: 'json'
      });
    });
  });
}

window.clickableTr = function() {
  $(".clickable_tr td:not(:has(a[href]))").each(function(i, el) {
    $(el).click(function() {
      var link  = $(this.closest('tr')).data("href")
      var remote  = $(this.closest('tr')).data("remote")
      if (remote) {
        $.ajax({
          url: link,
          type: "GET",
          dataType: 'script'
        });
      } else {
        window.location = link;
      }
    })
  });
}

window.colspans = function() {
  $('td.colspan').each(function(i, el) {
    var count = 0
    $(el).closest('table').find('tr th').each(function(i, el) {
      if ($(el).attr('colspan')) {
        count += parseInt($(el).attr('colspan'));
      } else {
        count += 1;
      }
    });
    $(el).attr('colspan', count);
  });
  $('.table-responsive').on('show.bs.dropdown', function () {
    $('.table-responsive').css( "overflow", "inherit" );
  });

  $('.table-responsive').on('hide.bs.dropdown', function () {
    $('.table-responsive').css( "overflow", "auto" );
  })
}

window.bsConfirmations = function() {
  $('[data-toggle=confirmation]').confirmation({
    rootSelector: '[data-toggle=confirmation]',
    btnOkClass: 'btn btn-success',
    btnCancelClass: 'btn btn-secondary delete'
  });
}

window.fakeDateField = function() {
  $(".fake_date_field").each(function(i,el) {
    if ($(el).val()) {
      this.type = 'date';
    }
    $(el).on('focus', function () {
      this.type = 'date';
      this.click();
    });
    $(el).on('focusout', function () {
      if (this.value == '') {
        this.type = 'text';
      }
    });
  });
}

window.toggleFields = function() {
  $("[data-behaviour='toggle_fields']").each(function(i, el) {
    toggleFieldsVisibility(el);
    $(el).change(function() {
      toggleFieldsVisibility(el);
    });
  });
}

window.toggleFieldsVisibility = function() {
  $("[data-dependency]").each(function(i,el) {
    target = $(this).data("dependency");
    values = $(this).data('dependencyvalue').toString();
    if(values.indexOf(',') > -1) {
      values = values.split(',');
    } else {
      values = [values];
    }
    condition = $(this).data('dependencycondition');
    target_value = $("#" + target).val();
    if (!target_value) {
      target_value = ' '
    }
    switch(condition) {
      case 'Not-equals':
        if ($.inArray( target_value, values ) == -1 && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop( "disabled", false );
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop( "disabled", true );
        }
        break;
      case 'Equals':
        if ($.inArray( target_value, values ) != -1 && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop( "disabled", false );
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop( "disabled", true );
        }
        break;
      case 'Contains':
        if ( String(target_value).indexOf(String(values)) >= 0 && target_value != '' ) {
          $(el).show();
          $(el).find('*').filter(':input:first').prop( "disabled", false );
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop( "disabled", true );
        }
      case 'Does not contain':
        if ( String(target_value).indexOf(String(values)) == -1 && target_value != '' ) {
          $(el).show();
          $(el).find('*').filter(':input:first').prop( "disabled", false );
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop( "disabled", true );
        }
      case 'Starts with':
        if (String(target_value).match("^" + String(values)) && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop( "disabled", false );
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop( "disabled", true );
        }
      case 'Does not start with':
        if ( String(target_value).match("^" + String(values)) == null && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop( "disabled", false );
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop( "disabled", true );
        }
      }
  });
}

window.tooltip = function() {
  $(".change_request, .sample_request").each(function(i, el) {
    $(el).click(function(event) {
      if (!$(el).hasClass('locked')) {
        $(".change_request, .sample_request").addClass('locked');
        target = $(el).data('target');
        tooltip = $("#" + target);
        container_width = $(el).closest('.scrolling-wrapper').width();
        element_position = $(el).offset().left;
        if ($(el).hasClass('sample_request')) {
          kind = 'sample_request'
        } else {
          kind = 'change_request'
        }
        adjustTooltip(kind, tooltip, element_position, container_width)
        tooltip.fadeIn();
        tooltip.find('.close').click(function(){
          tooltip.fadeOut();
          $(".change_request, .sample_request").removeClass('locked');
        });
      }
    });
  });
}

window.adjustTooltip = function(kind, tooltip, element_position, container_width) {
  if ( element_position + 400 > container_width) {
    var left = - 400
    tooltip.addClass('align-right');
  } else {
    var left = 0
  }
  if (kind == 'sample_request') {
    var top = 45
  } else {
    var top = - 15
  }
  tooltip.css({
    top: top + 'px',
    left: left + 'px'
  })
}

window.selectpicker = function() {
  $('.selectpicker').selectpicker();
}

window.updateSelect = function() {
  $("[data-update='address']").change( function(el){
    value = this.value;
    if(value != 'Seleziona...') {
      name = $(this).attr('id');
      target = $("#" + name);
      datatarget1 = $(this).data('target1');
      target1 = $("#" + datatarget1);
      datatarget2 = $(this).data('target2');
      target2 = $("#" + datatarget2);
      url = "/cities/get_enum?" + name + "=" + value;
      $.getJSON(url, function(json){
        $("#" + datatarget1).val(json['province']);
        target2.empty();
        target2.append($('<option>').text("Seleziona...").attr('value', ''));
        $.each(json[datatarget2], function(i, obj){
          target2.append($('<option>').text(obj.text).attr('value', obj.text));
        });
        if(json[datatarget2].length == 1) {
          $("#" + datatarget2 + " option:last").attr("selected",true);
        }
      });
    }
  });
}

window.showScheduleBtn = function() {
  $(".inline_select").each(function(i,el) {
    if ($(el).val() == 'installation') {
      $('#schedule').removeClass('d-none');
      $('#show_operations').removeClass('d-none');
    } else {
      $('#schedule').addClass('d-none');
      $('#show_operations').addClass('d-none');
    }
  });
}

window.inlineAjax = function(el, url, location_reload){
  id = $(el).closest("tr").attr("id");
  $.ajax({
    type: 'PATCH',
    url: url,
    beforeSend: function() {
      $(el).prop("disabled", true);
    },
    error: function(data) {
      $(el).prop("disabled", false);
      $(el).closest("tr").find("span").removeClass('d-none').addClass('alert-danger').html(data['message'])
      $(el).effect("highlight", {color: "#7bcc48",}, 1500)
    },
    success: function(data) {
      $(el).prop("disabled", false);
      if (data['code'] == '500') {
        $(el).closest("tr").find("p").removeClass('d-none').addClass('alert-danger').html(data['message'])
        $(el).effect("highlight", {color: "#ff4e3e", easing: 'easeInElastic'}, 1500)
      } else {
        $(el).closest("tr").find("p").addClass('d-none').removeClass('alert-danger').html('')
        $(el).effect("highlight", {color: "#7bcc48", easing: 'easeInElastic'}, 1500)
        if (location_reload == true) {
          // $('#operation_list').load(location.href + '#operation_list');
          location.reload();
        }
      }
    },
    data: {
      field: $(el).attr("name"),
      input: $(el).val(),
      url: url
    },
    dataType: 'json'
  });
}

window.inlineUpdate = function() {
  $(".inline_update").each(function(i,el) {
    var url = $(el).closest("tr").attr("data-url");
    if ($(el).is("input:text")){
      $(el).focusout(function() {
        inlineAjax($(el), url, true)
      })
    } else if ($(el).is('input[type="color"]')) {
      $(el).change(function(){
        inlineAjax($(el), url, true)
        $(el).closest("tr").attr("style", "border-left: " + $(el).val() + " 6px solid")
      })
    } else if ($(el).is("select")) {
      $(el).change(function(){
        inlineAjax($(el), url, false)
      })
    } else if ($(el).is('input[type="date"]')) {
      $(el).change(function(){
        inlineAjax($(el), url, true)
      })
    }
  });

  $(".inline_select").each(function(i,el) {
    $(el).change(function() {
      id = $(el).data('id');
      url = "/customers/" + $(el).data('customer-id') + "/activities/" + id + "/inline_update";
      showScheduleBtn();
      $.ajax({
        type: 'PATCH',
        url: url,
        beforeSend: function() {
          $(el).prop("disabled", true);
        },
        error: function(data) {
          $(el).prop("disabled", false);
          $("#p_" + id).removeClass('alert-success').addClass('alert-danger').fadeIn('slow');
          $("#p_" + id).html('<span>Errore. Riprovare!</span>');
          setTimeout(function() { $("#p_" + id).fadeOut('slow'); }, 3000);
        },
        success: function(data) {
          $(el).prop("disabled", false);
          if (data['code'] == '500') {
            $("#p_" + id).removeClass('alert-success').addClass('alert-danger').html('<span>Errore. Riprovare!</span>');
          }
          $("#p_" + id).fadeIn('slow');
          var colors = {
            'analisys':             'btn-warning',
            "deal":                 'btn-reddish',
            "installation":         'btn-primary',
            "finish":               'btn-success',
            "sales":                'btn-orange',
            "offer_confirmed":      'btn-greenish'
          }
          $(el).removeClass('btn-warning').removeClass('btn-reddish').removeClass('btn-primary').removeClass('btn-success').removeClass('btn-greenish');
          $(el).addClass(colors[$(el).val()]);
        },
        data: {status: $(el).val()},
        dataType: 'json'
      });
    });
  });
}
